// @ts-nocheck

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { FaFilter } from 'react-icons/fa';


const useStyles = makeStyles((theme) => ({
    button: {
        color: '#202020',
        border: '1px solid #EAECF0 !important',
        '&:hover': {},
        borderRadius: '8px !important',
        fontWeight: '500',
        width: '181px',
        fontSize: '14px !important',
        lineHeight: '20px !important',
        textTransform: 'unset !important',
        backgroundColor: '#fff !important',
        paddingTop: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        letterSpacing: '-0.05px',
        paddingBottom: '8px',
        boxShadow:
            '0px 1px 2px 0px rgba(24, 24, 28, 0.04), 0px 3px 4px -5px rgba(24, 24, 28, 0.03) !important',
    },
    disabledButton: {
        borderRadius: '5px !important',
        fontWeight: '500 !important',
        fontSize: '14px !important',
        lineHeight: '20px !important',
        textTransform: 'capitalize !important',
    },
}));

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme, width, isNone }) => ({
    '& .MuiPaper-root': {
        borderRadius: 8,
        border: '1px solid #E5E6E4 !important',
        marginTop: theme.spacing(1),
        minWidth: width,
        maxHeight: isNone ? 200 : 'auto',
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow: '0px 32px 41px -23px #10182812, 0px 2px 6px 0px #1018280F',
        '& .MuiMenu-list': {
            padding: '12px 10px',
        },
        '& .MuiMenuItem-root': {
            borderRadius: 4,
            padding: '10px 8px',
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
    '& .css-zddlty-MuiButtonBase-root-MuiButton-root': {
        backgroundColor: '#333',
    },
}));

export default function DropDownComponent({
    disabled,
    isNone = null,
    index,
    setSortBy,
    sortBy,
    options=['Sort by name','Sort by type','Sort by last updated'],
    width=142,
    button=null,
    type=null,
    iconOnly=false,
    anchorElReciptent=null, setAnchorElReciptent=null,
    defaultValue='',
    isMultiSelect=false
}) {
    let [anchorEl, setAnchorEl] = useState(null);
    if(anchorElReciptent!==null && setAnchorElReciptent!==null){
        anchorEl = anchorElReciptent
        setAnchorEl = setAnchorElReciptent
    }
    const [newListType, setNewListType] = useState([]);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (handleOnClick) => {
        handleOnClick()
        if (!isMultiSelect) {
            setAnchorEl(null);
        }
    };
    const classes = useStyles();
    const buttonRef = useRef();
    const menuRef = useRef();

    useEffect(() => {
        if (!isMultiSelect) return;

        const handleClickOutside = (event) => {
            if (buttonRef.current && buttonRef.current.contains(event.target)) {
                return;
            }
            setAnchorEl(null);
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open, isMultiSelect]);

    const isSelected = (item) => {
        if (isMultiSelect && Array.isArray(sortBy)) {
            if (item === "all") {
                return sortBy.length === 0;
            }
            return sortBy.includes(item);
        }
        return item === sortBy;
    };

    return (
        <div>
            <button ref={buttonRef} className="text-[#202020]" onClick={handleClick}><FaFilter/></button>
            <StyledMenu
                className="max-h-96"
                isNone={isNone}
                width={
                    isNone
                        ? buttonRef.current
                            ? buttonRef.current.getBoundingClientRect().width
                            : 150
                        : 150
                }

                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: isNone ? 'left' : 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: isNone ? 'left' : 'right',
                }}
                // sx={{ minWidth: '310px !important' }}

                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose(() => { })}
            >   {options.map(item=><MenuItem
                className={`!font-Inter-Medium`}
                key={index}
                onClick={() => handleClose(() => {
                    setSortBy(item)
                })}
                disableRipple
            >
                <p className={`text-sm w-[${width}px] tracking-[-0.18px] flex gap-x-2  font-medium items-center ${isSelected(item)?'font-semibold':'font-normal'}`}>
                    {isMultiSelect && <input type="checkbox" checked={isSelected(item)} readOnly className="mr-1" />}
                    {item}
                </p>
                    </MenuItem>)}
            </StyledMenu>
        </div>
    );
}